// PrivacyPolicy.jsx
import React, { useEffect, useState } from 'react';
import { Modal, Input, Button } from 'antd';
import styles from "./RegistrationForm.module.css";
import { ButtonCustom } from '../BootstrapComponents/ButtonCustom';
import { BreathAPIs } from '../APIs/BreathAPIs'
import PhoneInput from '../components/PhoneInput';


const PhoneVerificationModal = ({ modalVisible, phoneNumber, closeModal, onVerificationSuccess, fromBookingForm = false, setPhoneState = null }) => { 
    const [otp, setOtp] = useState('');
    const [verifyToken, setVerifyToken] = useState('');

    const [isOTPRequested, setIsOTPRequested] = useState(null);

    const [verificationStatus , setVerificationStatus] = useState('');

    

    const handleCancel = () => {
        closeModal();
    };

    const formatPhoneNumber = (sanitizedValue) => {
        return sanitizedValue ? `+1 (${sanitizedValue.slice(0, 3)}) ${sanitizedValue.slice(3, 6)}-${sanitizedValue.slice(6)}` : '';
    }

    
    const handleCreateOTP = () => {
        setIsOTPRequested(true);
        console.log('Phone',phone)
          BreathAPIs.sendPhoneVerification('+1' + fromBookingForm ? phone : phoneNumber)
            .then(response => {
                if (response && response.data && response.data.success) {
                    setVerificationStatus('OTP sent successfully. Please check your phone.');
                    if (response.data.success && response.data.token) {
                        setVerifyToken(response.data.token);
                    } else {
                        setVerificationStatus('Failed to retrieve OTP token.');
                    }
                } else {
                    const errorMessage = response.data && response.data.message
                        ? response.data.message
                        : 'Failed to send OTP. Please try again.';
                    setVerificationStatus(errorMessage);
                }
            })
            .catch(error => {
                if (error?.response?.data?.tokenExpired) {
                    setVerificationStatus('Error: Token expired. Please request a new OTP.');
                } else {
                    console.error('Error sending OTP:', error);
                    const errorMessage = error.response && error.response.data && error.response.data.message
                        ? error.response.data.message
                        : 'An error occurred while sending OTP. Please try again.';
                    setVerificationStatus(errorMessage);
                }
            });
    };
    
    const handleVerify = () => {
        BreathAPIs.verifyOTP(otp, verifyToken)
            .then(response => {
                if (response && response.data && response.data.success) {
                    setVerificationStatus('OTP verified successfully.');
                    if (response.data.success && response.data.verified) {
                        setVerifyToken(response.data.verified);
                        onVerificationSuccess();
                        closeModal();
                    } else {
                        setVerificationStatus('Failed to verify OTP.');
                    }
                } else {
                    const errorMessage = response.data && response.data.message
                        ? response.data.message
                        : 'OTP verification failed. Please try again.';
                    setVerificationStatus(errorMessage);
                }
            })
            .catch(error => {
                if (error?.response?.data?.tokenExpired) {
                    setVerificationStatus('Error: Token expired. Please request a new OTP.');
                } else {
                    console.error('Error verifying OTP:', error);
                    const errorMessage = error.response && error.response.data && error.response.data.message
                        ? error.response.data.message
                        : 'An error occurred while verifying OTP. Please try again.';
                    setVerificationStatus(errorMessage);
                }
            });
    };
    const sanitizePhoneNumber = (input) => {
    const sanitized = input.replace(/\D/g, '');
    return sanitized.startsWith('1') ? sanitized.slice(1) : sanitized;
    };

    const [phone, setPhone] = useState(sanitizePhoneNumber(phoneNumber))
    useEffect(() => {
        setPhone(sanitizePhoneNumber(phoneNumber))
    }, [modalVisible])

    return (
    <Modal
            title="Phone Number Verification"
            open={modalVisible}
            onCancel={handleCancel}
            footer={null}
            destroyOnClose
        >
            <div>
                {
                    fromBookingForm &&
                    <div className={`form-floating mb-3 input-left-box ${styles['input-left-box']}`}>
                            <PhoneInput 
                            addCode={true} className="form-control" type="text" name="phone" placeholder='Phone' 
                                onChange={(e) => {
                                    setPhone(sanitizePhoneNumber(e.target.value));
                                    const next = sanitizePhoneNumber(e.target.value) ?? ""
                                    setPhoneState?.(next);
                                    console.log(e.target.value)
                                }}
                                value={phone} required />
                            <span className={styles['left-box-component']}>+1</span>
                            <label htmlFor="phone" className="form-label">Phone</label>
                    </div>
                   
                }

                {isOTPRequested ? <>
                    <p>{verificationStatus}</p>
                    <Input
                        placeholder="OTP"
                        value={otp}
                        onChange={(e) => setOtp(e.target.value)}
                        className={'mb-2'}
                    />
                    <ButtonCustom variant={"primary"} text={"Verify"} isLoading={false} onClick={handleVerify} />
                </> : <>
                    <p>Click "Send OTP" to generate a One-Time Password (OTP) {!fromBookingForm &&<span>that will be sent to {formatPhoneNumber(phone)}:</span>}</p>
                    <ButtonCustom variant={"primary"} text={"Send OTP"} isLoading={false} onClick={handleCreateOTP}  
                    disabled={phone?.length !==10 && fromBookingForm}
                    />
                </>}


            </div>
        </Modal>
    );
};

export default PhoneVerificationModal;
